<div class="container-max">
  <div class="header fade-in">
    <div class="dashboard-header">
      <h1>Dashboard</h1>
      <p>High-level metrics and client health overview.</p>
    </div>
    <div class="filter-content">
      <div class="filter-section">
        <div class="date-filter">
          <input type="date" [(ngModel)]="startDate" (change)="onDateChange()" class="date-input" id="startDate">
          <span class="date-separator">to</span>
          <input type="date" [(ngModel)]="endDate" (change)="onDateChange()" class="date-input" id="endDate">
        </div>
        <div class="checkbox-filters">
          <label class="checkbox-label">
            <input type="checkbox" [(ngModel)]="thisMonth" (change)="onThisMonthChange()" id="thisMonth">
            <span class="checkmark"></span>
            This Month
          </label>
          <label class="checkbox-label">
            <input type="checkbox" [(ngModel)]="prevMonth" (change)="onPrevMonthChange()" id="prevMonth">
            <span class="checkmark"></span>
            Previous Month
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="stats-grid fade-in" style="animation-delay: 0.1s;">
    @if (role === 'ADMIN') {
      <div class="stat-card">
        <div class="stat-icon" style="color: #3b82f6;">👥</div>
        <div class="stat-info">
          @if (isLoadingClient) {
            <div class="loading-container2">
              <div class="loading-spinner"></div>
              <!-- <p class="loading-text">Just a moment — loading your device insights...</p> -->
            </div>
          }
          @else {
            <h3 id="totalClients">
              {{ totalClients }}
            </h3>
          }
          <p>Total Clients</p>
        </div>
      </div>
    }
    <div class="stat-card">
      <div class="stat-icon">
        <div class="stat-symbol-circle" style="background-color: #39FF14;"></div>
      </div>
      <div class="stat-info">
        @if (isLoadingOnlineOffline) {
        <div class="loading-container2">
          <div class="loading-spinner"></div>
          <!-- <p class="loading-text">Just a moment — loading your device insights...</p> -->
        </div>
        }
        @else {
        <h3 id="activeSessions">
          {{ overallOnlinePercentage }}%
        </h3>
        }
        <p>Overall Online Time Percentage</p>
      </div>
    </div>
    <div class="stat-card">
      <div class="stat-icon">
        <div class="stat-symbol-circle" style="background-color: #FF3131;"></div>
      </div>
      <div class="stat-info">
        @if (isLoadingOnlineOffline) {
        <div class="loading-container2">
          <div class="loading-spinner"></div>
          <!-- <p class="loading-text">Just a moment — loading your device insights...</p> -->
        </div>
        }
        @else {
        <h3 id="avgOnlineTime">
          {{ overallOfflinePercentage }}%
        </h3>
        }
        <p>Overall Offline Time Percentage</p>
      </div>
    </div>
    @if (role === 'ADMIN') {
      <div class="stat-card">
        <div class="stat-icon" style="color: #9b59b6;">💻</div>
        <div class="stat-info">
          @if (isLoadingDevices) {
            <div class="loading-container2">
              <div class="loading-spinner"></div>
              <!-- <p class="loading-text">Just a moment — loading your device insights...</p> -->
            </div>
          }
          @else {
            <h3 id="totalDevices">
              {{ totalDevices }}
            </h3>
          }
          <p>Total Devices</p>
        </div>
      </div>
    }
  </div>

  <div class="section-header fade-in" style="animation-delay: 0.2s;">
    <h2>Client Health Overview</h2>
  </div>

  <div class="client-cards-grid fade-in" style="animation-delay: 0.3s;">
    @if (isLoadingCardData) {
    <div class="loading-container">
      <div class="loading-spinner"></div>
      <p class="loading-text">Just a moment — loading your client insights...</p>
    </div>
    }
    @else {
    @for (item of clientCardData; track $index) {
    <div class="client-card" [class.details-visible]="item.isDetailsVisible">
      <div class="aurora-bg"></div>

      <div class="card-header">
        <div class="header-title">
          <h3>
            {{ item.company_name }}
          </h3>
          <span class="industry-badge">
            {{ item.industry_type }}</span>
        </div>
        <!-- Only the info button should toggle details -->
        <button class="info-btn" type="button" (click)="toggleDetails(item)">
          <div class="info-icon"></div>
        </button>
      </div>

      <div class="card-body">
        <div class="primary-stat">
          <div class="stat-value">
            <strong>
              {{ item.totalMacs }}</strong>
            <span>Total Devices</span>
          </div>
          <div class="device-icon"></div>
        </div>

        <div class="uptime-summary">
          <p class="summary-title">Device Uptime Health</p>
          <div class="uptime-progress-bar">
            <div class="progress-segment excellent" [style.width.%]="item.excellentPercent" [title]="item.devicesAbove95 + ' devices > 95%'"></div>
            <div class="progress-segment good" [style.width.%]="item.goodPercent" [title]="item.devicesBetween90And95 + ' devices 90-95%'"></div>
            <div class="progress-segment attention" [style.width.%]="item.attentionPercent" [title]="item.devicesBelow90 + ' devices < 90%'"></div>
          </div>
          <div class="uptime-legend">
            <div class="legend-item">
              <span class="dot excellent"></span>
              <span>
                {{ item.devicesAbove95 }} > 95%</span>
            </div>
            <div class="legend-item">
              <span class="dot good"></span>
              <span>
                {{ item.devicesBetween90And95 }} 90-95%</span>
            </div>
            <div class="legend-item">
              <span class="dot attention"></span>
              <span>
                {{ item.devicesBelow90 }}

                < 90%</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Details panel - only visible when toggled -->
      <div class="card-details-panel">
        <div class="detail-item">
          <div class="email-icon"></div>
          <span>
            {{ item.email }}</span>
        </div>
        <div class="detail-item">
          <div class="phone-icon"></div>
          <span>
            {{ item.phone_no }}</span>
        </div>
        <div class="detail-item">
          <div class="location-icon"></div>
          <span>
            {{ item.address }}</span>
        </div>
      </div>

      <div class="card-footer">
        <button class="view-devices-btn" [attr.data-client-id]="item.userId" type="button" (click)="openModal(item)">
          <span>View Devices</span>
          <div class="arrow-icon"></div>
        </button>
      </div>
    </div>
    }
    }
  </div>
  @if (isModalOpen) {
  <app-device-mac-modal [deviceMacArray]="deviceMacArray" [filterType]="filterType" [startDate]="startDate" [endDate]="endDate" (closeModal)="closeModal($event)"></app-device-mac-modal>
  }
</div>
